import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { createTrainingSessionTpl } from "../../../../services/training-session-tpl";

interface CoachTrainingSessionTplNewProps {
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function CoachTrainingSessionTplNew(props: CoachTrainingSessionTplNewProps) {
    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            name: event.target.name.value,
            description: event.target.description.value,
            goals: event.target.goals.value
        }
        createTrainingSessionTpl(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    return (
        <Modal className="training-session-tpl-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("new_training_session_tpl") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                            <Form.Control type="text" name="name" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="description">
                            <Form.Label>{ t("description") }</Form.Label>
                            <Form.Control name="description" as="textarea" rows={5} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="goals">
                            <Form.Label>{ t("goals") }</Form.Label>
                            <Form.Control name="goals" as="textarea" rows={5} />
                        </Form.Group>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}